import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Chip,
  Collapse,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { AddButtonIcon } from '../Buttons/AddButtonIcon';
import { DeleteButtonIcon } from '../Buttons/DeleteButtonIcon';

// const CountryAccordion = ({ countries }) => {
//   return (
//     <Accordion>
//       <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
//         <Typography>Countries</Typography>
//       </AccordionSummary>
//       <AccordionDetails>
//         <TableContainer component={Paper}>
//           <Table>
//             <TableHead>
//               <TableRow>
//                 <TableCell>Country</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {countries.map((country) => (
//                 <CountryRow key={country.id} country={country} />
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>
//       </AccordionDetails>
//     </Accordion>
//   );
// };

// const CountryRow = ({ country }) => {
//   const [open, setOpen] = useState(false);

//   return (
//     <>
//       <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
//         <TableCell>
//           <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
//             {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
//           </IconButton>
//         </TableCell>
//         <TableCell>{country.name}</TableCell>
//       </TableRow>
//       <TableRow>
//         <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
//           <Collapse in={open} timeout="auto" unmountOnExit>
//             <RegionAccordion regions={country.regions} />
//           </Collapse>
//         </TableCell>
//       </TableRow>
//     </>
//   );
// };

const RegionAccordion = ({
  regions,
  handleAddVillage,
  handleDeleteVillage,
  setModalSelectRegions,
  setModalSelectDepartements,
  setModalSelectCommunes,
  setSelectedRegion,
  setSelectedDepartement,
  setSelectedCommune,
  onDelete,
  isPreview,
  t,
}) => {
  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t('region_name')}</TableCell>
              <TableCell align="right">
                {!isPreview && <AddButtonIcon title={''} onClick={() => setModalSelectRegions(true)} />}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {regions
              .sort((a, b) => a.name.localeCompare(b.name))
              .map((region, index) => (
                <RegionRow
                  key={index}
                  region={region}
                  setModalSelectDepartements={setModalSelectDepartements}
                  setModalSelectCommunes={setModalSelectCommunes}
                  departements={region?.departementList}
                  handleAddVillage={handleAddVillage}
                  handleDeleteVillage={handleDeleteVillage}
                  setSelectedRegion={setSelectedRegion}
                  setSelectedDepartement={setSelectedDepartement}
                  setSelectedCommune={setSelectedCommune}
                  onDelete={onDelete}
                  isPreview={isPreview}
                  t={t}
                />
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
const RegionRow = ({
  region,
  departements,
  handleAddVillage,
  handleDeleteVillage,
  setModalSelectDepartements,
  setModalSelectCommunes,
  setSelectedRegion,
  setSelectedDepartement,
  setSelectedCommune,
  onDelete,
  isPreview,
  t,
}) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>{region.name}</TableCell>
        <TableCell className="d-flex justify-content-end">
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => {
              setOpen(!open);
              setSelectedRegion(region.id);
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
          {!isPreview && <DeleteButtonIcon title="" onClick={() => onDelete('region', region.id)} />}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit className="p-3">
            <DepartmentAccordion
              setModalSelectDepartements={setModalSelectDepartements}
              setModalSelectCommunes={setModalSelectCommunes}
              departements={departements}
              handleAddVillage={handleAddVillage}
              handleDeleteVillage={handleDeleteVillage}
              setSelectedDepartement={setSelectedDepartement}
              setSelectedCommune={setSelectedCommune}
              onDelete={onDelete}
              isPreview={isPreview}
              t={t}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

const DepartmentAccordion = ({
  departements,
  handleAddVillage,
  handleDeleteVillage,
  setModalSelectDepartements,
  setModalSelectCommunes,
  setSelectedDepartement,
  setSelectedCommune,
  onDelete,
  isPreview,
  t,
}) => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t('departement_name')}</TableCell>
            <TableCell align="right">
              {!isPreview && <AddButtonIcon title={''} onClick={() => setModalSelectDepartements(true)} />}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {departements
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((department) => (
              <DepartmentRow
                key={department.id}
                department={department}
                setModalSelectCommunes={setModalSelectCommunes}
                communes={department?.communeList}
                handleAddVillage={handleAddVillage}
                handleDeleteVillage={handleDeleteVillage}
                setSelectedDepartement={setSelectedDepartement}
                setSelectedCommune={setSelectedCommune}
                onDelete={onDelete}
                isPreview={isPreview}
                t={t}
              />
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const DepartmentRow = ({
  department,
  communes,
  setModalSelectCommunes,
  handleAddVillage,
  handleDeleteVillage,
  setSelectedDepartement,
  setSelectedCommune,
  onDelete,
  isPreview,
  t,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>{department.name}</TableCell>
        <TableCell className="d-flex justify-content-end">
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => {
              setOpen(!open);
              setSelectedDepartement(department.id);
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
          {!isPreview && <DeleteButtonIcon title="" onClick={() => onDelete('departement', department.id)} />}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit className="p-3">
            <CommuneAccordion
              communes={communes}
              setModalSelectCommunes={setModalSelectCommunes}
              handleAddVillage={handleAddVillage}
              handleDeleteVillage={handleDeleteVillage}
              setSelectedCommune={setSelectedCommune}
              onDelete={onDelete}
              isPreview={isPreview}
              t={t}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

const CommuneAccordion = ({
  communes,
  setModalSelectCommunes,
  handleAddVillage,
  handleDeleteVillage,
  setSelectedCommune,
  onDelete,
  isPreview,
  t,
}) => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t('commune_name')}</TableCell>
            <TableCell align="right">
              {!isPreview && <AddButtonIcon title={''} onClick={() => setModalSelectCommunes(true)} />}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {communes
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((commune) => (
              <CommuneRow
                key={commune.id}
                commune={commune}
                villages={commune?.villageList}
                handleAddVillage={handleAddVillage}
                handleDeleteVillage={handleDeleteVillage}
                setSelectedCommune={setSelectedCommune}
                onDelete={onDelete}
                isPreview={isPreview}
                t={t}
              />
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const CommuneRow = ({
  commune,
  villages,
  handleAddVillage,
  handleDeleteVillage,
  setSelectedCommune,
  onDelete,
  isPreview,
  t,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>{commune.name}</TableCell>
        <TableCell className="d-flex justify-content-end">
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => {
              setOpen(!open);
              setSelectedCommune(commune.id);
            }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
          {!isPreview && <DeleteButtonIcon title="" onClick={() => onDelete('commune', commune.id)} />}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit className="p-3">
            <VillageAccordion
              villages={villages}
              handleAddVillage={handleAddVillage}
              handleDeleteVillage={handleDeleteVillage}
              isPreview={isPreview}
              t={t}
            />
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

const VillageAccordion = ({ villages, handleDeleteVillage, handleAddVillage, isPreview, t }) => {
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel5a-content" id="panel5a-header">
        {/* flex box */}
        <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" width="100%">
          <Typography>{t('village_url')}</Typography>
          {!isPreview && <AddButtonIcon title={''} onClick={() => handleAddVillage()} />}
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box display="flex" flexDirection="column">
          {villages?.length === 0 && (
            <Alert variant="outlined" severity="info">
              {t('no_villages_found')}
            </Alert>
          )}
          {villages?.length > 0 && (
            <Box sx={{ marginY: 1 }}>
              <Stack direction="row" spacing={1}>
                {!isPreview &&
                  villages
                    ?.sort((a, b) => a.name.localeCompare(b.name))
                    .map((village) => (
                      <Chip
                        key={village.id}
                        label={`${village.name} (${village.code})`}
                        onDelete={() => handleDeleteVillage(village.id)}
                        color="primary"
                        variant="outlined"
                      />
                    ))}
                {isPreview &&
                  villages
                    ?.sort((a, b) => a.name.localeCompare(b.name))
                    .map((village) => (
                      <Chip
                        key={village.id}
                        label={`${village.name} (${village.code})`}
                        color="primary"
                        variant="outlined"
                      />
                    ))}
              </Stack>
            </Box>
          )}
        </Box>
      </AccordionDetails>
    </Accordion>
  );
};

export default function NestedAccordion({
  country,
  regions,
  handleAddVillage,
  handleDeleteVillage,
  setModalSelectRegions,
  setModalSelectDepartements,
  setModalSelectCommunes,
  setSelectedRegion,
  setSelectedDepartement,
  setSelectedCommune,
  onDelete,
  t,
  isPreview,
}) {
  if (country === null)
    return (
      <Alert variant="outlined" severity="info">
        {t('select_country_name')}
      </Alert>
    );

  return (
    <RegionAccordion
      regions={regions}
      setModalSelectRegions={setModalSelectRegions}
      setModalSelectDepartements={setModalSelectDepartements}
      setModalSelectCommunes={setModalSelectCommunes}
      handleAddVillage={handleAddVillage}
      handleDeleteVillage={handleDeleteVillage}
      setSelectedRegion={setSelectedRegion}
      setSelectedDepartement={setSelectedDepartement}
      setSelectedCommune={setSelectedCommune}
      onDelete={onDelete}
      isPreview={isPreview}
      t={t}
    />
  );
}
